import React from 'react';
import { Link } from 'react-router-dom';

import { locale } from '@trqk/utils';

import { FULL_PATHS, HASHES } from '../../../constants';

export const UploadsAreFinished = ({
    remove,
}: ToastRenderContentProps<
    OnGroupStoppedInput<FilenameInput, Record<string, never>>
>): JSX.Element => (
        <div style={{ width: 410 }} className="px-2">
            <div className="font-bold text-primary-500 tracking-wider mb-2">
                {locale.enUS.INGESTION.TOASTS.UPLOADS_ARE_FINISHED.GOOD_NEWS}
            </div>
            <div className="mb-2">
                {
                    locale.enUS.INGESTION.TOASTS.UPLOADS_ARE_FINISHED
                        .YOUR_UPLOADS_ARE_FINISHED
                }
            </div>
            <div className="font-normal text-tertiary-500">
                {
                    locale.enUS.INGESTION.TOASTS.UPLOADS_ARE_FINISHED
                        .YOU_CAN_SEE_RESULTS
                }
                &nbsp;
                <Link
                    to={({ search }) => ({
                        hash: HASHES.MANAGE_STATEMENTS.COMPLETE,
                        pathname: FULL_PATHS.MANAGE_STATEMENTS_CHARTS,
                        search,
                    })}
                >
                    <button
                        className="text-primary-500 underline"
                        type="button"
                        onClick={(): void => {
                            remove({
                                canceled: false,
                                success: true,
                            });
                        }}
                    >
                        {
                            locale.enUS.INGESTION.TOASTS.UPLOADS_ARE_FINISHED
                                .COMPLETE_TAB
                        }
                    </button>
                </Link>
                &nbsp;
                {
                    locale.enUS.INGESTION.TOASTS.UPLOADS_ARE_FINISHED
                        .OF_THE_STATEMENT_MANAGER
                }
            </div>
        </div>
    );
